<div class="dft" *ngIf="selection" [class.dark]="isDark"
     [style.left.px]="posLeft" [style.top.px]="posTop">

  <span class="dft-label" [title]="toolLabel">{{ toolLabel }}</span>

  <div class="dft-sep"></div>

  <!-- Color de línea -->
  <div class="dft-anchor">
    <button class="dft-btn" (click)="togglePanel('line-color')" title="Color de línea">
      <i class="bi bi-pencil"></i>
      <span class="dft-swatch" [style.background]="lineColor"></span>
    </button>
    <div class="dft-panel" *ngIf="panel === 'line-color'">
      <div class="dft-pal-row" *ngFor="let row of palette">
        <button *ngFor="let color of row" class="dft-pal-cell"
          [style.background]="color" [title]="color"
          [class.dft-pal-active]="color === lineColor"
          (click)="setLineColor(color)"></button>
      </div>
    </div>
  </div>

  <!-- Color de relleno -->
  <div class="dft-anchor" *ngIf="meta?.hasFill">
    <button class="dft-btn" (click)="togglePanel('fill-color')" title="Color de relleno">
      <i class="bi bi-paint-bucket"></i>
      <span class="dft-swatch" [style.background]="fillColor"></span>
    </button>
    <div class="dft-panel" *ngIf="panel === 'fill-color'">
      <div class="dft-pal-row" *ngFor="let row of palette">
        <button *ngFor="let color of row" class="dft-pal-cell"
          [style.background]="color" [title]="color"
          (click)="setFillColor(color)"></button>
      </div>
    </div>
  </div>

  <!-- Grosor -->
  <div class="dft-anchor">
    <button class="dft-btn" (click)="togglePanel('width')" title="Grosor de línea">
      <span class="dft-width-preview" [style.height.px]="lineWidth"></span>
    </button>
    <div class="dft-panel dft-panel-list" *ngIf="panel === 'width'">
      <button *ngFor="let w of lineWidths" class="dft-list-item"
        [class.dft-list-active]="w === lineWidth" (click)="setLineWidth(w)">
        <span class="dft-width-preview" [style.height.px]="w"></span>
        <span>{{ w }} px</span>
      </button>
    </div>
  </div>

  <!-- Estilo de línea -->
  <div class="dft-anchor">
    <button class="dft-btn" (click)="togglePanel('style')" title="Estilo de línea">
      <i class="bi bi-border-style"></i>
    </button>
    <div class="dft-panel dft-panel-list" *ngIf="panel === 'style'">
      <button class="dft-list-item" [class.dft-list-active]="isDashActive([])" (click)="setLineDash([])">
        <span class="dft-dash dft-dash-solid"></span><span>Sólida</span>
      </button>
      <button class="dft-list-item" [class.dft-list-active]="isDashActive([6,4])" (click)="setLineDash([6,4])">
        <span class="dft-dash dft-dash-dashed"></span><span>Discontinua</span>
      </button>
      <button class="dft-list-item" [class.dft-list-active]="isDashActive([2,2])" (click)="setLineDash([2,2])">
        <span class="dft-dash dft-dash-dotted"></span><span>Punteada</span>
      </button>
    </div>
  </div>

  <div class="dft-sep"></div>

  <!-- Plantilla -->
  <div class="dft-anchor">
    <button class="dft-btn" (click)="togglePanel('template')" title="Plantilla de estilo">
      <i class="bi bi-palette"></i>
    </button>
    <div class="dft-panel dft-panel-list" *ngIf="panel === 'template'">
      <button class="dft-list-item" (click)="saveAsTemplate()">
        <i class="bi bi-save"></i><span>Guardar como predeterminado</span>
      </button>
      <button class="dft-list-item" *ngIf="hasTemplate" (click)="applyTemplate()">
        <i class="bi bi-magic"></i><span>Aplicar predeterminado</span>
      </button>
      <button class="dft-list-item" *ngIf="hasTemplate" (click)="clearTemplate()">
        <i class="bi bi-x-circle"></i><span>Restablecer predeterminado</span>
      </button>
    </div>
  </div>

  <!-- Clonar -->
  <button class="dft-btn" (click)="clone()" title="Clonar">
    <i class="bi bi-copy"></i>
  </button>

  <!-- Candado -->
  <button class="dft-btn" [class.dft-active]="isLocked" (click)="toggleLock()"
    [title]="isLocked ? 'Desbloquear' : 'Bloquear'">
    <i class="bi" [class.bi-lock-fill]="isLocked" [class.bi-unlock]="!isLocked"></i>
  </button>

  <!-- Visibilidad -->
  <button class="dft-btn" (click)="toggleVisible()" [title]="isVisible ? 'Ocultar' : 'Mostrar'">
    <i class="bi" [class.bi-eye]="isVisible" [class.bi-eye-slash]="!isVisible"></i>
  </button>

  <!-- Ajustes -->
  <button class="dft-btn" (click)="openSettings()" title="Ajustes">
    <i class="bi bi-gear"></i>
  </button>

  <div class="dft-sep"></div>

  <!-- Eliminar -->
  <button class="dft-btn dft-danger" (click)="remove()" title="Eliminar (Supr)">
    <i class="bi bi-trash"></i>
  </button>
</div>
